require('./gdpr.scss');

(function($) {
	const $elm = $('#policy');
	const $key = $('#policy').data('key');
	const $closeButton = $('.gdpr .dismiss');
	const $acceptButton = $('.gdpr-eu .accept');

	const setCookie = (key) => {
		if (window.Cookies) {
			window.Cookies.set(key, 'true', { expires: 90 });
		}
	};

	const getCookie = (key) => {
		return (window.Cookies) ? window.Cookies.get(key) : false;
	};

	const loadComponents = () => {
		if (getCookie($key)) {
			return false;
		}

		$elm.addClass("animate");
		if ($elm.hasClass('gdpr')) {
			setCookie($key);
		}
	};
	loadComponents();

	$acceptButton.on('click', function(e) {
		setCookie($key);
		$elm.addClass('hide');
	});

	$closeButton.on('click', function(e) {
		$elm.addClass('hide');
	});
})(jQuery);